'use client'

import React, { useEffect } from 'react'
import Link from 'next/link'
import { useSearchParams } from 'next/navigation'
import { toast } from 'react-toastify'
import { loginWithCredentials } from '@/utils/auth'
import { RegisterWizard } from '@/components/otherPages/Register'

export default function LoginRegister() {
  const sp = useSearchParams()

  const tab = (sp.get('tab') || '').toLowerCase()
  const prefillAccount = sp.get('account') || ''
  const lineId = sp.get('lineId') || ''
  const redirect = sp.get('redirect') || sp.get('RedirectUrl') || '/'

  const [account, setAccount] = React.useState(prefillAccount)
  const [password, setPassword] = React.useState('')
  const [rememberMe, setRememberMe] = React.useState(false)

  const showRegisterTab = async () => {
    const { Tab } = await import('bootstrap/dist/js/bootstrap.bundle.min.js')
    const triggerEl = document.querySelector('#register-tab')
    if (triggerEl) {
      const tabTrigger = new Tab(triggerEl)
      tabTrigger.show()
    }
  }

  useEffect(() => {
    if (tab === 'register') {
      showRegisterTab()
    }
  }, [tab])

  const handleLogin = async () => {
    await loginWithCredentials({
      account,
      password,
      rememberMe,
      onSuccess: () => {
        toast.success('會員登入成功')
        console.log('badge:0')
        if (redirect) {
          setTimeout(() => {
            window.location.href = redirect
          }, 80)
        }
      },
      onError: (message) => alert(message || '帳號或密碼錯誤'),
    })
  }

  return (
    <>
      <head>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no"
        />
      </head>

      <section className="login-register container">
        <h2 className="d-none">登入 & 加入會員</h2>

        <ul className="nav nav-tabs mb-5" id="LoginOrRegister" role="tablist">
          <li className="nav-item" role="presentation">
            <a
              className="nav-link nav-link_underscore active"
              id="login-tab"
              data-bs-toggle="tab"
              href="#tab-item-login"
              role="tab"
            >
              登入
            </a>
          </li>
          <li className="nav-item" role="presentation">
            <a
              className="nav-link nav-link_underscore"
              id="register-tab"
              data-bs-toggle="tab"
              href="#tab-item-register"
              role="tab"
              onClick={async (e) => {
                e.preventDefault()
                await showRegisterTab()
              }}
            >
              加入會員
            </a>
          </li>
        </ul>

        <div className="tab-content pt-2" id="LoginOrRegister_tab_content">
          <div
            className="tab-pane fade show active"
            id="tab-item-login"
            role="tabpanel"
            aria-labelledby="login-tab"
          >
            <div className="login-form">
              <form
                onSubmit={(e) => e.preventDefault()}
                className="needs-validation"
              >
                <div className="form-floating mb-3">
                  <input
                    name="login_account"
                    type="text"
                    className="form-control form-control_gray"
                    placeholder="帳號 / 手機 *"
                    value={account}
                    onChange={(e) => setAccount(e.target.value)}
                    required
                  />
                  <label>帳號 / 手機 *</label>
                </div>

                <div className="pb-3"></div>

                <div className="form-floating mb-3">
                  <input
                    name="login_password"
                    type="password"
                    className="form-control form-control_gray"
                    placeholder="密碼 *"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                  />
                  <label>密碼 *</label>
                </div>

                <div className="d-flex align-items-center mb-3 pb-2">
                  <div className="form-check mb-0">
                    <input
                      name="remember"
                      className="form-check-input form-check-input_fill"
                      type="checkbox"
                      checked={rememberMe}
                      onChange={(e) => setRememberMe(e.target.checked)}
                    />
                    <label className="form-check-label text-secondary">
                      記住我
                    </label>
                  </div>
                  <Link href="/reset_password" className="btn-text ms-auto">
                    忘記密碼?
                  </Link>
                </div>

                <button
                  className="btn btn-primary w-100 text-uppercase"
                  type="submit"
                  onClick={handleLogin}
                >
                  登入
                </button>

                <div className="customer-option mt-4 text-center">
                  <span className="text-secondary">還不是會員?</span>{' '}
                  <a
                    href="#tab-item-register"
                    className="btn-text js-show-register"
                    onClick={async (e) => {
                      e.preventDefault()
                      await showRegisterTab()
                    }}
                  >
                    加入會員
                  </a>
                </div>
              </form>
            </div>
          </div>

          <div
            className="tab-pane fade"
            id="tab-item-register"
            role="tabpanel"
            aria-labelledby="register-tab"
          >
            <RegisterWizard
              defaultMobile={prefillAccount}
              lineId={lineId}
              redirectTo={redirect}
            />
          </div>
        </div>
      </section>
    </>
  )
}
